document.addEventListener('ShoptetDOMAdvancedOrderLoaded', function() {  
    $('.extras-wrap').prepend('<div onclick="shoptet.modal.close();" class="extra btn btn-secondary">Zpět do obchodu</div>')  
    $('.h1.advanced-order-suggestion').text('Doporučujeme přikoupit')
})


document.addEventListener('ShoptetDOMCartContentLoaded', function() { 
    
    $('.cart-widget-product').each(function(){
        $(this).find('.cart-widget-product-name').append('<span class="amountProduct">'+$(this).find('.cart-widget-product-amount input.amount').val()+' '+$(this).find('.cart-widget-product-unit').text()+'</span>')
    })

})

if($('.id--16, .id--17').length){
    $.get('/action/Cart/GetCartContent/?orderingProcessActive=1', function(data){   
        $('.cart-item[data-micro="cartItem"]').each(function(){
            get_id = $(this).attr('data-micro-sku')
            link = $(data.payload.content).find('.removeable[data-micro-sku="'+get_id+'"] .cart-p-image a').attr('href')
            image = $(data.payload.content).find('.removeable[data-micro-sku="'+get_id+'"] .cart-p-image img').attr('data-src').replace('related', 'detail')
            if(!$(this).find('.right').length){
                $(this).wrapInner('<div class="right"></div>')
                $(this).prepend('<div class="image"><a href="'+link+'"><img src="'+image+'" alt="'+$(this).find('a[data-testid="recapItemName"]').text()+'"></a></div>')
            }
        })
    })
    $('.cart-inner').prepend($('.cart-header'))
}

if($('.id--9').length){
    const storageKey = window.location.host + "-productData";
    function fetchDataAndStore() {
        $.getJSON("/user/documents/isbn.json", function (data) {
            sessionStorage.setItem(storageKey, JSON.stringify(data));
            updateCartAvailability(data);
        }).fail(function () {
            console.error("❌ Chyba: Nelze načíst JSON soubor.");
        });
    }
    function formatCzechDate(dateString) {
        if (!dateString || !/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
            return dateString;
        }
        let [year, month, day] = dateString.split("-");
        return `${parseInt(day, 10)}.${parseInt(month, 10)}.${year}`;
    }
    function updateCartAvailability(data) {
        $(".removeable").each(function () {
            let productSku = $(this).attr("data-micro-sku");
            let match = data.find(item => item.code === productSku);

            if (match) {
                let formattedDate = formatCzechDate(match.productNumber);
                let availabilityCell = $(this).find(".p-availability");
                if (!availabilityCell.find(".deliveryDateJSON").length) {
                    availabilityCell.append(`<span class="deliveryDateJSON" style="display:block;">naskladnění od ${formattedDate}</span>`);
                }

                console.log(`✅ Nalezeno: ${match.code} -> Naskladnění: ${formattedDate}`);
            }
        });
    }
    const storedData = sessionStorage.getItem(storageKey);
    if (storedData) {
        console.log("✅ Načteno ze storage.");
        updateCartAvailability(JSON.parse(storedData));
    } else {
        console.log("🔄 Načítám data z JSON souboru...");
        fetchDataAndStore();
    }
    function mhProductInfoMove(){
        $('.cart-table tr').each(function(){
          var findcenazakus = $(this).find('.p-price.p-cell').html();
          var findptotal = $(this).find('.p-total');
          $(this).find('.p-name').append('<div class="avail">'+$(this).find('.p-availability').html()+'</div>')
          $(findptotal).prepend('<span class="cenazaks">'+findcenazakus+'</span>');
        })
    };
    mhProductInfoMove()
    document.addEventListener('ShoptetDOMCartContentLoaded', function () {
        mhProductInfoMove();
    });
}

if($('.id--17').length){
//    $('.cart-content>.co-contact-information .phone-form-group').after($('.form-group label[for="login"]').closest('.form-group'))
}